import { Map } from 'immutable';
import createCachedSelector from 're-reselect';
var getTray = function getTray(state, scope) {
  return state.getIn([scope, 'OutcomePicker', 'tray']) || Map();
};
export var getOutcomeList = createCachedSelector(function (state, scope) {
  return getTray(state, scope).get('list');
}, function (list) {
  return list ? list.toJS() : [];
})(function (_, scope) {
  return scope;
});
var pagination = function pagination(state, scope) {
  return getTray(state, scope).get('pagination') || Map();
};
export var getListPage = function getListPage(state, scope) {
  return pagination(state, scope).get('page');
};
export var getListTotal = function getListTotal(state, scope) {
  return pagination(state, scope).get('total');
};